export default "__VITE_ASSET__31c360c3__"